import { render } from "./MenuSeasons.vue?vue&type=template&id=bd05b8b0&ts=true"
import script from "./MenuSeasons.vue?vue&type=script&lang=ts"
export * from "./MenuSeasons.vue?vue&type=script&lang=ts"

import "./MenuSeasons.vue?vue&type=style&index=0&id=bd05b8b0&lang=stylus"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__